import React, { FC, useCallback, useState } from 'react';
import { IconButton, ListItemSecondaryAction, Tooltip } from '@material-ui/core';
import { FaUserLock as KeyIcon } from '@react-icons/all-files/fa/FaUserLock';

interface Props {
  contactCreated?: boolean;
  canCreateAccess?: boolean;
  onClickCreateAccess?: () => void;
  onClickRevokeAccess?: () => void;
}

const CustomerAccessAction: FC<Props> = ({
  onClickCreateAccess,
  onClickRevokeAccess,
  canCreateAccess,
  contactCreated,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const onClick = contactCreated ? onClickRevokeAccess : onClickCreateAccess;
  const tooltip = contactCreated ? "Supprimer l'accès client" : 'Créer un accès client';

  return (
    <ListItemSecondaryAction>
      <Tooltip
        open={tooltipOpen}
        onClose={useCallback(() => setTooltipOpen(false), [setTooltipOpen])}
        onOpen={useCallback(() => setTooltipOpen(true), [setTooltipOpen])}
        title={tooltip}
      >
        <IconButton edge='end' onClick={onClick} disabled={!canCreateAccess}>
          <KeyIcon color={contactCreated ? '#4caf50' : undefined} />
        </IconButton>
      </Tooltip>
    </ListItemSecondaryAction>
  );
};

export default CustomerAccessAction;
